import "@styles/exames-procedimentos.css";
import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import Layout from "@components/shared/layout";
import MenuLateralUsuario from "@components/menu_lateral_usuario";
import AccordionGroup from "@components/accordion_group";
import AccordionChild from "@components/accordion_child";
import FormAutorizacao from "@components/ExamesProcedimentos/FormAutorization";
import AreaResultado from "@components/ExamesProcedimentos/Result/area_resultado";
import FormSolicitacao from "@components/ExamesProcedimentos/FormProfisisonal";
import FormProcedimentos from "@components/ExamesProcedimentos/FormProcedimentos";
import {
  autorizarProcedimentos,
  updateExameState,
  resetBeneficiarioState,
  resetExameState,
  fetchGuia,
  requireBiometrics,
  saveBiometrics,
  clearBiometrics,
} from "@store/actions";
import { getPrestador, updatePrestador } from "@store/actions";
import AjaxLoader from "@components/shared/ajax_loader";
import CustomSnackbar from "@components/shared/custom_snackbar";
import m from "@utils/strings";
import userManager from "@utils/userManager";
import RequisicaoAutorizacaoProcedimentos from "@config/types/requests/RequisicaoSolicitacaoProcedimentos";
import BiometricsModal from "@components/BiometricsModal";

class ExamesProcedimentos extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeKey: "1",
      numberOfAccordions: 3,
      beneficiarioDTO: {},
      profissionalExecutante: {},
      procedimentos: [],
      showLoader: false,
      showPrestadorLoader: false,
      showGuiaLoader: false,
      resultadoExame: {},
      isGoingToResetAllStates: false,
      snackbarMsg: "",
      isAccordionsBlocked: false,
      apiError: false,
      msgErrorApi: "",
    };
    this.isFetchingPrestador = false;
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    if (_.isEmpty(this.props.prestador)) {
      this.setState({ showPrestadorLoader: true });
      this.getUpdatePrestador();
    }
    this.verifiyIfUserIsAuthenticated();
    document.addEventListener("keydown", this.handleKeyDown, false);
    this.props.resetBeneficiarioState();
    this.props.clearBiometrics();
    this.props.resetExameState();
    this.setActiveAccordionMiddleware("1");
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown, false);
  }

  componentDidUpdate() {
    this.verifiyIfUserIsAuthenticated();
  }

  verifiyIfUserIsAuthenticated = () => {
    const { user } = this.props;
    if (!user || user.expired) {
      userManager.signinRedirect();
    }
  };

  getUpdatePrestador = () => {
    const { user } = this.props;
    if (user != null && user.profile != null) {
      if (!this.isFetchingPrestador) {
        this.isFetchingPrestador = true;
        let cpfCnpj =
          user.profile.prestador instanceof Array
            ? user.profile.prestador[0]
            : user.profile.prestador;
        this.props.getPrestador(cpfCnpj, (result) => {
          this.props.updatePrestador(result);
          this.setState({ showPrestadorLoader: false });
        });
      }
    }
  };

  handleKeyDown(event) {
    if (event.key === "m" && event.ctrlKey) {
      if (
        this.state.resultadoExame &&
        this.state.resultadoExame.data &&
        this.state.resultadoExame.data.SolicitacaoProcedimento.Senha
      ) {
        this.resetAllStateExceptForBeneficiario();
      }
    } else if (!this.state.isAccordionsBlocked) {
      switch (event.key) {
        case "F7":
          if (this.state.activeKey == "1") this.closeAllAccordions();
          else this.handleAccordionSelect("1");
          break;
        case "F8":
          if (this.state.activeKey == "2") this.closeAllAccordions();
          else this.handleAccordionSelect("2");
          break;
        case "F9":
          if (this.state.activeKey == "3") this.closeAllAccordions();
          else this.handleAccordionSelect("3");
          break;
        default:
          break;
      }
    }
  }

  setActiveAccordionMiddleware = (accordionToOpen) => {
    this.setState({ activeKey: accordionToOpen });

    switch (accordionToOpen) {
      case "1":
        this.focusFirstFieldAutorizacao();
        break;
      case "2":
        this.focusFirstFieldSolicitacao();
        break;
      case "3":
        this.focusFirstFieldProcedimentos();
    }
  };

  closeAllAccordions = () => {
    if (this.state.activeKey !== "") this.setActiveAccordionMiddleware("");
  };

  openNextAccordion = () => {
    let nextKey = parseInt(this.state.activeKey, 10) + 1;
    if (nextKey > this.state.numberOfAccordions) nextKey = 1;
    this.setActiveAccordionMiddleware(nextKey.toString());
  };

  handleAccordionSelect = (activeKey) => {
    if (this.state.isAccordionsBlocked) return;
    this.setActiveAccordionMiddleware(activeKey);
  };

  blockAllAccordionsAndFields = () => {
    this.blockAllSolicitacaoFields();
    this.blockAllProcedimentosFields();
  };

  updateDadosBeneficiario = (data) => {
    this.setState({
      beneficiarioDTO: data.beneficiarioDTO,
    });
  };

  updateDadosSolicitacao = (data, callback) => {
    this.setState(
      {
        profissionalExecutante: data.profissionalExecutante,
      },
      () => {
        if (_.isFunction(callback)) {
          callback();
        }
      }
    );
  };

  handleEligibilitySubmit = (error, result = null) => {
    if (error != null) {
      this.setState({
        snackbarMsg:
          m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_COMUNICACAO_SERVICO,
      });
      this.clickChild();
      this.setApiError(true, error);
      this.closeAllAccordions();
      return;
    };
    const {
      data: { Biometria },
    } = result;
    if (Biometria.Utiliza) {
      this.props.requireBiometrics();
    }
  }

  handleBiometricsMessageReceived = (data) => {
    if (data.response == 400) {
      this.setState({
        snackbarMsg:
          data.message,
      });
      this.clickChild();
      this.setApiError(true, data.message);
      this.closeAllAccordions();
      this.props.clearBiometrics();
      return;
    }
    this.setState({
      snackbarMsg: data.message,
    });
    this.props.clearBiometrics();
  }
  
  autorizarExame = (procedimentos) => {
    let params = undefined;
    try {
      params = new RequisicaoAutorizacaoProcedimentos(
        this.state.beneficiarioDTO,
        this.state.profissionalExecutante,
        procedimentos
      );
    } catch (e) {
      this.setState({ snackbarMsg: e.message });
      this.clickChild();
      return null;
    }
    if (params) {
      this.setState({ showLoader: !this.state.showLoader });
      this.props.autorizarProcedimentos(
        params,
        (result) => {
          if (
            (result?.data?.SolicitacaoProcedimento?.CodigoMotivoNegativa ?? "").length > 0
          ) {
            this.setState({
              showLoader: !this.state.showLoader,
              resultadoExame: {},
              apiError: true,
              msgErrorApi: `${result.data.SolicitacaoProcedimento.CodigoMotivoNegativa} - ${result.data.SolicitacaoProcedimento.DescricaoMotivoNegativa}`,
            });
          } else {
            this.setState({
              procedimentos: procedimentos,
              showLoader: !this.state.showLoader,
              resultadoExame: result
            });
            this.props.updateExameState(result);
          }

          this.closeAllAccordions();
          this.blockAllAccordionsAndFields();
        },
        (error) => {
          this.setState({
            snackbarMsg: m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_COMUNICACAO_SERVICO,
            showLoader: !this.state.showLoader,
            resultadoExame: "API_ERROR",
            apiError: true,
            msgErrorApi: error
          });
          this.blockAllAccordionsAndFields();
          this.closeAllAccordions();
          this.clickChild();
        }
      );
    }
  };

  blockAllAccordions = () => {
    this.setState({ isAccordionsBlocked: true });
  };

  resetAllStates = () => {
    this.setState({
      beneficiarioDTO: {},
      profissionalExecutante: {},
      procedimentos: [],
      isAccordionsBlocked: false,
      apiError: false,
      resultadoExame: {},
      msgErrorApi: "",
      showLoader: false,
    });

    this.resetFormFieldsStates();
    this.resetFormFieldsStatesProcedimento();
    this.resetFormFieldsStatesSolicitacao();
    this.props.resetBeneficiarioState();
    this.props.resetExameState();
    this.props.clearBiometrics();
    this.setActiveAccordionMiddleware("1");
  };

  resetAllStateExceptForBeneficiario = () => {
    this.setState({
      profissionalExecutante: {},
      procedimentos: [],
      isAccordionsBlocked: false,
      resultadoExame: {},
      apiError: false,
      msgErrorApi: ""
    });
    this.resetFormFieldsStatesProcedimento();
    this.resetFormFieldsStatesSolicitacao();
    this.props.resetExameState();
    this.setActiveAccordionMiddleware("2");
  };

  getGuia = (senha) => {
    if (!_.isEmpty(this.state.resultadoExame)) {
      this.setState({ showGuiaLoader: true });
      this.props.fetchGuia(
        senha,
        (result) => {
          this.setState({ showGuiaLoader: false });
          const url = window.URL.createObjectURL(
            new Blob([result.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("target", "_blank");
          document.body.appendChild(link);
          link.click();
        },
        (error) => {
          this.setState({ showGuiaLoader: false });
          this.setState({
            snackbarMsg: m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_ERRO_IMPRESSAO,
          });
          this.clickChild();
        }
      );
    }
  };

  displayAutorizacaoResultTable = () => {
    this.editProcedimentoFormForResponse(
      this.state.resultadoExame.data.SolicitacaoProcedimento.ProcedimentoExames,
      this.state.resultadoExame.data.SolicitacaoProcedimento.StatusSolicitacao
    );
    this.setActiveAccordionMiddleware("3");
  };

  setApiError = (apiError, msgError) => {
    this.setState({
      apiError: apiError,
      msgErrorApi: msgError
    });
  };

  render() {
    const { user, beneficiario, exame, prestador } = this.props;
    const { showLoader, showPrestadorLoader, showGuiaLoader } = this.state;

    const loader = showLoader ? <AjaxLoader /> : "";
    const prestadorLoader = showPrestadorLoader ? (
      <AjaxLoader
        ajaxMessage={
          m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_LOADER_BUSCANDO_PRESTADOR
        }
      />
    ) : (
      ""
    );
    const guiaLoader = showGuiaLoader ? (
      <AjaxLoader
        ajaxMessage={m.TELA_EXAMES_PROCEDIMENTOS.MENSAGEM_AJAX_LOADER_GUIA}
      />
    ) : (
      ""
    );

    return (
      <div>
        {loader}
        {prestadorLoader}
        {guiaLoader}
        <Layout
          user={user}
          iconePath={this.props.iconPath}
          alt={this.props.pageTitle}
          content={this.props.pageTitle}
        />
        <MenuLateralUsuario
          beneficiario={beneficiario}
          exame={exame}
          resetStates={this.resetAllStateExceptForBeneficiario}
        />
        <AccordionGroup
          openNextAccordion={this.openNextAccordion}
          activeKey={this.state.activeKey}
          onSelect={this.handleAccordionSelect}
          childs={[
            <AccordionChild
              componentToRender={
                <div>
                  <FormAutorizacao
                    beneficiario={beneficiario}
                    willAuthorize={false}
                    updateDadosBeneficiario={this.updateDadosBeneficiario}
                    openNextAccordion={this.openNextAccordion}
                    closeAllAccordions={this.closeAllAccordions}
                    setInitialFieldsState={(e) =>
                      (this.resetFormFieldsStates = e)
                    }
                    onEligibilitySubmit={this.handleEligibilitySubmit}
                    activeAccordion={this.state.activeKey}
                    prestador={prestador}
                    MSGestureEvent
                    tipoAtendimento={this.props.tipoAtendimento}
                    callSnackbarSucess={this.clickChildSuccess}
                    callSnackbarFailure={(msg) => {
                      this.setState({ snackbarMsg: msg }, this.clickChild);
                    }}
                    focusFirstFieldAutorizacao={(e) =>
                      (this.focusFirstFieldAutorizacao = e)
                    }
                    validateAutorizacaoFields={(e) =>
                      (this.validateAutorizacaoFields = e)
                    }
                    blockAllAccordions={this.blockAllAccordions}
                    setApiError={this.setApiError}
                  />
                </div>
              }
              title={
                m.TELA_EXAMES_PROCEDIMENTOS.TITULO_ACCORDION_DADOS_BENEFICIARIO
              }
              keyboardCommandKey="F7"
              keyAccordion="1"
              key="1"
            />,
            <AccordionChild
              componentToRender={
                <div>
                  <FormSolicitacao
                    openNextAccordion={this.openNextAccordion}
                    updateDadosSolicitacao={this.updateDadosSolicitacao}
                    setInitialFieldsState={(e) =>
                      (this.resetFormFieldsStatesSolicitacao = e)
                    }
                    activeAccordion={this.state.activeKey}
                    validateSolicitacaoFields={(e) =>
                      (this.validateSolicitacaoFields = e)
                    }
                    focusFirstFieldSolicitacao={(e) =>
                      (this.focusFirstFieldSolicitacao = e)
                    }
                    blockAllFields={(e) => (this.blockAllSolicitacaoFields = e)}
                    resetAllStates={this.resetAllStates}
                  />
                </div>
              }
              title={
                m.TELA_EXAMES_PROCEDIMENTOS.TITULO_ACCORDION_DADOS_SOLICITACAO
              }
              keyboardCommandKey="F8"
              keyAccordion="2"
              key="2"
            />,
            <AccordionChild
              componentToRender={
                <div>
                  <FormProcedimentos
                    autorizarExame={this.autorizarExame}
                    setInitialFieldsState={(e) =>
                      (this.resetFormFieldsStatesProcedimento = e)
                    }
                    activeAccordion={this.state.activeKey}
                    focusFirstFieldProcedimentos={(e) =>
                      (this.focusFirstFieldProcedimentos = e)
                    }
                    parcialmenteAutorizadoResponseStatus={(e) =>
                      (this.editProcedimentoFormForResponse = e)
                    }
                    resetAllStates={this.resetAllStates}
                    blockAllFields={(e) =>
                      (this.blockAllProcedimentosFields = e)
                    }
                    callSnackbarFailure={(msg) => {
                      this.setState({ snackbarMsg: msg }, this.clickChild);
                    }}
                  />
                </div>
              }
              title={
                m.TELA_EXAMES_PROCEDIMENTOS.TITULO_ACCORDION_DADOS_PROCEDIMENTOS
              }
              keyboardCommandKey="F9"
              keyAccordion="3"
              key="3"
            />,
          ]}
        />
        <BiometricsModal
          url={beneficiario?.data?.Biometria?.Url}
          onBiometryResponse={this.handleBiometricsMessageReceived}
          onClose={this.resetAllStates}
        />
        <AreaResultado
          exameResultado={this.state.resultadoExame}
          beneficiario={beneficiario}
          closeAllAccordions={this.closeAllAccordions}
          resetAllStates={this.resetAllStates}
          activeAccordion={this.state.activeKey}
          fetchGuia={this.getGuia}
          procedimentos={this.state.procedimentos}
          displayAutorizacaoResultTable={this.displayAutorizacaoResultTable}
          exame={this.props.exame}
          apiError={this.state.apiError}
          msgErrorApi={this.state.msgErrorApi}
        />
        <CustomSnackbar
          setClick={(click) => (this.clickChild = click)}
          variant="error"
          duration={4000}
          content={this.state.snackbarMsg}
        />
        <CustomSnackbar
          setClick={(click) => (this.clickChildSuccess = click)}
          variant="success"
          duration={4000}
          content={
            m.TELA_EXAMES_PROCEDIMENTOS.NOTIFICACAO_SUCESSO_BENEFICIARIO_ATIVO
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.oidc.user,
    beneficiario: state.beneficiario,
    exame: state.exame,
    prestador: state.prestador,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      autorizarProcedimentos,
      updateExameState,
      resetBeneficiarioState,
      resetExameState,
      getPrestador,
      updatePrestador,
      fetchGuia,
      requireBiometrics,
      saveBiometrics,
      clearBiometrics,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExamesProcedimentos);
